import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { App } from './App.tsx'
import store from './redux/configureStore';
import './index.css'
import { BrowserRouter } from 'react-router-dom';

const { reduxStore, persistor } = store;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ReduxProvider store={reduxStore}>
            <PersistGate persistor={persistor}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </PersistGate>
        </ReduxProvider>
    </React.StrictMode>,
)
